import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import { useLazyComponent } from '@trello/use-lazy-component';

import type { DiscoveryAdBoardsHomeProps } from './DiscoveryAdBoardsHome';

export const LazyDiscoveryAdBoardsHomeContainer: FunctionComponent<
  DiscoveryAdBoardsHomeProps
> = (props) => {
  const DiscoveryAdBoardsHomeContainer = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "discovery-ad-boards-home" */ './DiscoveryAdBoardsHomeContainer'
      ),
    { namedImport: 'DiscoveryAdBoardsHomeContainer' },
  );

  return (
    <Suspense fallback={null}>
      <DiscoveryAdBoardsHomeContainer {...props} />
    </Suspense>
  );
};
